
(function () {

  function addCarouselSlideEventListener() {
    $('#getting-started-carousel').on('slide.bs.carousel', function (e) {
      var slideToIndex = $(e.relatedTarget).index();
      var slideFromIndex = $(this).find('.active').index();
      var slideFromIndicator = $('.carousel-indicators > li[data-slide-to="' +
        slideFromIndex + '"]');
      var slideToIndicator = $('.carousel-indicators > li[data-slide-to="' +
        slideToIndex + '"]');

      slideFromIndicator.addClass('carousel-indicator-background-default');
      slideToIndicator.removeClass('carousel-indicator-background-default').addClass('bg-primary');
    });
  }

  function setGettingStartedVideoFrame() {
    var gsVideoIframe = $('#getting-started-video-iframe');
    if (gsVideoIframe.length) {
      var gsVideoSrc = gsVideoIframe.attr('data-link-src');
      gsVideoIframe.attr('src', gsVideoSrc);
    }
  }

  function ready() {

    setGettingStartedVideoFrame();

    var trainingContent = $('.help-training-thumbnails');
    if (trainingContent.length) {

      var active = $('.help-training-thumbnails a.active').length;
      if (!active) {
        var firstItem = $('.help-training-thumbnails a').first();
        if (firstItem.length) {
          firstItem.addClass('active');
        }
      }
    }

    addCarouselSlideEventListener();
  }

  function getTrainingVideoUrl(id) {
    var baseUrl = $('#help-training-video').attr('data-base-url');
    return baseUrl + '/' + id;
  }

  function setTrainingVideoStart(start) {
    var currentUrl = $('#help-training-video').attr('src');
    var curBase = currentUrl.split('?')[0];
    var startPos = Math.round(start);
    return curBase + '?start=' + startPos + '&autoplay=1';
  }

  function transcriptClick() {
    var url = this.href;
    if (url) {
      var idx = url.indexOf('#');
      if (idx !== -1) {
        var start = url.substr(idx + 1);
        $('#help-training-video').attr('src', setTrainingVideoStart(start));

        gdhelp2.utils.notifyHelpVideoChanged('help-training-video');
      }
    }

    return true;
  }

  function trainingThumbnailClick() {
    var url = this.href;
    if (url) {
      var idx = url.indexOf('#');
      if (idx !== -1) {
        var id = url.substr(idx + 1);
        var self = $(this);

        $('.help-training-thumbnails a').removeClass('active');
        self.addClass('active');

        $('#help-training-video').attr('src', getTrainingVideoUrl(id));
        $('#help-training-details').html(self.attr('data-details'));
        $('#help-training-transcript').html(self.attr('data-transcript'));
        $('#help-training-name').html(self.attr('data-name'));
        $('#help-training-transcript a').on('click', transcriptClick);

        gdhelp2.utils.notifyHelpVideoChanged('help-training-video');
      }
    }

    return true;
  }

  $('.help-training-thumbnails a').on('click', trainingThumbnailClick);
  $('#help-training-transcript a').on('click', transcriptClick);
  $(document).ready(ready);

}());
